import { styled } from '@mui/material/styles';
import { useKeycloak } from '@react-keycloak/web';
import FusePageSimple from '../../../@fuse/core/FusePageSimple';
import Graphic from './graphics';
import Tables from './tables';
import GraphicService from './graphics/GraphicService';
import Filter from '../filter';

const Root = styled(FusePageSimple)(({ theme }) => ({
  '& .FusePageSimple-header': {
    backgroundColor: theme.palette.background.paper,
    borderBottomWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.divider,
  },
  '& .FusePageSimple-toolbar': {},
  '& .FusePageSimple-content': {},
  '& .FusePageSimple-sidebarHeader': {},
  '& .FusePageSimple-sidebarContent': {},
}));

function NivelesServicio() {
  const { keycloak } = useKeycloak();
  const roleKeycloak = keycloak?.realmAccess?.roles[0];

  console.log('roleKeycloak->', roleKeycloak);

  return (
    <>
      {['NOC', 'Administrador'].includes(roleKeycloak) && (
        <Root
          content={
            <div className="p-24 w-full">
              <div className="flex mb-4">
                <div className="w-3/4" style={{ height: '100%' }}>
                  <div className="flex-col bg-white m-10 rounded-lg mt-0 p-10">
                    <Graphic />
                    <Tables />
                    <GraphicService />
                  </div>
                </div>
                <div className="w-1/4">
                  <div className="flex-col bg-white m-10 rounded-lg mt-0">
                    <Filter component="niveles_servicio" />
                  </div>
                </div>
              </div>
            </div>
          }
          scroll="content"
        />
      )}
    </>
  );
}

export default NivelesServicio;
